import { useEffect, useState } from 'react';
import {
  disabilityDefinition,
  isDisabilityObservableLabel,
  yesNoTrueFalseOptions,
} from 'data/datas/genericData';
import Form, { FormItem } from 'components/Base/Form';
import { Text } from 'components/Base/Typography';
import { TextArea } from 'components/Base/TextField';
import { RadioGroup } from 'components/Base/Radio';
import { SRadio } from './SADocumentationForm.styles';
// import RadioLabel from 'components/Shared/RadioLabel';
import { TSADocumentationFormProps } from './SADocumentationForm.types';
import { hasSADocumentationFormFields } from './SADocumentationForm.data';
import DisabilityOptions from 'components/Shared/DisabilityOptions';
import { Row } from 'components/Base/Grid';
import { Colors } from 'core/CssVariables';

const SADocumentationForm = ({
  conversion,
  form,
}: TSADocumentationFormProps) => {
  const { setFieldsValue } = form;
  const [isRequiredForDisability, setIsRequiredForDisability] = useState<
    boolean | undefined
  >();
  const {
    observableDisability,
    trainedFor,
    requiredBecauseOfDisability: isRequired,
  } = hasSADocumentationFormFields;

  useEffect(() => {
    if (!conversion) {
      return;
    }
    setFieldsValue({
      observableDisability: !!conversion?.observableDisability,
      trainedFor: conversion.trainedFor || '',
      requiredBecauseOfDisability: true,
    });
    setIsRequiredForDisability(true);
  }, [conversion]);

  return (
    <Form
      form={form}
      name="sa-documentation-form"
      autoComplete="off"
      requiredMark={false}
      initialValues={{
        isObservable: conversion?.observableDisability || null,
      }}
      id="sa-documentation-form"
      scrollToFirstError
    >
      <Row>
        <Text fontLevel={4} className="mb-2">
          Is the animal required because of a disability?
        </Text>
      </Row>
      <Row>
        <Text fontLevel={5} color={Colors.DarkGrey} className="mb-2">
          {disabilityDefinition}
        </Text>
      </Row>
      <FormItem
        {...isRequired}
        rules={[
          {
            type: 'boolean',
            required: true,
            message: 'This field is required!',
          },
        ]}
        className="mb-0 mb-0"
      >
        <RadioGroup onChange={e => setIsRequiredForDisability(e.target.value)}>
          {yesNoTrueFalseOptions.map(({ value, label }) => (
            <SRadio value={value} label={label} key={label} />
          ))}
        </RadioGroup>
      </FormItem>
      {isRequiredForDisability && (
        <>
          <FormItem {...trainedFor} className="mt-0">
            <TextArea placeholder="Type here" />
          </FormItem>
          <Text fontLevel={5} fontWeight={500}>
            {isDisabilityObservableLabel}
          </Text>
          <FormItem {...observableDisability} className="mt-4 mb-0">
            <RadioGroup>
              <DisabilityOptions />
            </RadioGroup>
          </FormItem>
        </>
      )}
    </Form>
  );
};

export default SADocumentationForm;
